/**
 * Return avatar initials using profile data as the source of truth.
 *
 * Firebase Auth users do not consistently carry displayName, especially for
 * invite-created accounts. The Firestore user profile is therefore preferred
 * when it is available.
 */
export function getUserInitials(authUser, fallback = "??", userProfile = null) {
  const firstName = cleanString(userProfile?.firstName);
  const lastName = cleanString(userProfile?.lastName);
  const profileInitials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  if (profileInitials) return profileInitials;

  const displayName =
    cleanString(userProfile?.displayName) || cleanString(authUser?.displayName);
  const displayNameInitials = initialsFromDisplayName(displayName);
  if (displayNameInitials) return displayNameInitials;

  const email = cleanString(userProfile?.email) || cleanString(authUser?.email);
  const emailInitials = initialsFromEmail(email);
  if (emailInitials) return emailInitials;

  return fallback;
}

function cleanString(value) {
  return typeof value === "string" ? value.trim() : "";
}

function initialsFromDisplayName(displayName) {
  if (!displayName) return "";

  const parts = displayName.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
  }

  return parts[0]?.charAt(0).toUpperCase() || "";
}

function initialsFromEmail(email) {
  if (!email.includes("@")) return "";

  const localPart = email.split("@")[0];
  const parts = localPart.split(/[._-]+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
  }

  return localPart.charAt(0).toUpperCase();
}
